
const SuspanseLoader = () => {
  return <div>loading...</div>;
};

export default SuspanseLoader;
